export default "__VITE_ASSET__39025465__"